import { Command } from 'commander'
import { createClient } from '../../client.js'
import { handleError, EXIT_VALIDATION_ERROR } from '../../lib/errors.js'
import { isQuiet, printQuiet, printJson, printSuccess } from '../../output.js'
import { confirm, isInteractive } from '../../lib/confirm.js'

export const servicesDeleteCommand = new Command(`delete`)
  .description(`Delete a service`)
  .argument(`<id>`, `Service ID`)
  .option(`--force`, `Skip confirmation prompt`)
  .action(async (serviceId: string, opts) => {
    const json = servicesDeleteCommand.parent?.parent?.opts().json ?? false
    try {
      if (!opts.force) {
        if (json) {
          process.stderr.write(
            JSON.stringify({
              error: `VALIDATION_ERROR`,
              message: `--force is required with --json`,
              exitCode: EXIT_VALIDATION_ERROR,
            }) + `\n`
          )
          process.exit(EXIT_VALIDATION_ERROR)
        }
        const confirmed = await confirm(
          `Delete service ${serviceId}? This cannot be undone. [y/N] `
        )
        if (!confirmed) {
          if (!isInteractive()) {
            process.stderr.write(
              `Use --force to skip confirmation in non-interactive mode.\n`
            )
            process.exit(EXIT_VALIDATION_ERROR)
          }
          process.stderr.write(`Aborted.\n`)
          return
        }
      }

      const client = createClient()
      const result = await client.services.delete({
        serviceId,
        forceDelete: opts.force ?? false,
      })

      if (isQuiet()) {
        printQuiet(serviceId)
        return
      }

      if (json) {
        printJson(result)
      } else {
        printSuccess(`Service ${serviceId} deleted.`)
      }
    } catch (error) {
      handleError(error, json)
    }
  })
